import { render, staticRenderFns } from "./LProjectSessionsMenu.vue?vue&type=template&id=850bfa7e&scoped=true&"
import script from "./LProjectSessionsMenu.vue?vue&type=script&lang=js&"
export * from "./LProjectSessionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./LProjectSessionsMenu.vue?vue&type=style&index=0&id=850bfa7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850bfa7e",
  null
  
)

export default component.exports